import { render } from 'solid-js/web';
import Layout from './Layout';
import Home from './pages/Home';
import UserSettings from './UserSettings';
import AdminUsers from './AdminUsers';
import AdminQuizzes from './AdminQuizzes';
import QuizEditor from './QuizEditor';
import { Show } from 'solid-js';
import { useUserContext } from './UserContext';

function AdminUsersGuard() {
  const [userStore] = useUserContext() as any;
  return (
    <Show when={userStore.role === 'admin'} fallback={<div>Unauthorized</div>}>
      <AdminUsers />
    </Show>
  );
}

function AdminQuizzesGuard() {
  const [userStore] = useUserContext() as any;
  return (
    <Show when={userStore.role === 'admin'} fallback={<div>Unauthorized</div>}>
      <AdminQuizzes />
    </Show>
  );
}

function QuizEditorGuard() {
  const [userStore] = useUserContext() as any;
  return (
    <Show when={userStore.role === 'admin'} fallback={<div>Unauthorized</div>}>
      <QuizEditor />
    </Show>
  );
}

import { AdminContextProvider } from "./AdminContext";
import { UserContextProvider } from "./UserContext";
import { QuizContextProvider } from "./QuizContext";
import { Router, Route } from "@solidjs/router";
// Bring in styles for math and code highlighting
import 'katex/dist/katex.min.css';
import 'highlight.js/styles/github.css';
import StudentJoin from './pages/StudentJoin';
import StudentQuiz from './pages/StudentQuiz';
import AdminLiveQuiz from './pages/AdminLiveQuiz';
import PublicLiveQuiz from './pages/PublicLiveQuiz';

const app = document.getElementById('app');


if (app) {
  render(() => (
    <>
      <UserContextProvider>
        <AdminContextProvider>
          <QuizContextProvider>
            <Router root={Layout}>
              <Route path="/" component={Home} />
              <Route path="/user-settings" component={UserSettings} />
              <Route path="/manage-users" component={() => <AdminUsersGuard />} />
              <Route path="/manage-quizzes" component={() => <AdminQuizzesGuard />} />
              <Route path="/quiz/:id/edit" component={() => <QuizEditorGuard />} />
              <Route path="/join" component={StudentJoin} />
              <Route path="/q/:code" component={StudentQuiz} />
              <Route path="/admin/live/:id" component={AdminLiveQuiz} />
              <Route path="/public/:code" component={PublicLiveQuiz} />
            </Router>
          </QuizContextProvider>
        </AdminContextProvider>
      </UserContextProvider>
      <footer class="footer" style={{ display: 'none' }}>
        <div class="container">
          <span class="text-muted"><a href="http://bramas.fr">bramas.fr</a></span>{' | '}
          <span class="text-muted"><a href="#" onclick={() => {}}>Se déconnecter</a></span>
        </div>
      </footer>
    </>
  ), app);
}